import { createFileRoute } from "@tanstack/react-router";
import { EmployeeMaterialActionStepper } from "../../components/employee_material_action_stepper";

export const Route = createFileRoute("/employee/issue/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <EmployeeMaterialActionStepper
      title="Materiaal uitgeven"
      secondStepName="Uitgeven"
      mode="issue"
    />
  );
}
